import React from 'react';
import { Field, FormikContextType, useFormikContext } from 'formik';
import { Fields, Columns } from 'modules/af_cm_ui_kit/components';
import { VARIANTS_TYPES } from 'modules/af_cm_ui_kit/components/TextField/variants.types';
import { FIELDS, FIELDS_QUESTIONS, FormValues } from '../Form/Form.types';
import { Props } from './FuturePension.types';
import { getIsRetired } from '../Form/Form';
import get from 'get-value';

const FuturePension: React.FC<Props> = ({ prefix, useOfFunds }) => {
  const { values }: FormikContextType<FormValues> = useFormikContext();
  const getValue = (field: FIELDS) => {
    return get(values, `${prefix}.${field}`);
  };

  const isRetired = getIsRetired(values, prefix.split('.')[0]);

  return (
    <>
      <Field
        component={Fields.Text}
        title={FIELDS_QUESTIONS.STATE_PENSION}
        name={`${prefix}.${FIELDS.STATE_PENSION}`}
        variant={VARIANTS_TYPES.CURRENCY}
        disabled={isRetired}
      />

      <Field
        component={Fields.Text}
        title={FIELDS_QUESTIONS.DEFINED_BENEFIT_FUTURE}
        name={`${prefix}.${FIELDS.DEFINED_BENEFIT}`}
        variant={VARIANTS_TYPES.CURRENCY}
        disabled={isRetired}
      />

      <Columns spacing={4}>
        <Field
          component={Fields.Text}
          title={FIELDS_QUESTIONS.PER_TRANSFERRED_ON_DEATH_UNDER_DEF_BENEFIT}
          name={`${prefix}.${FIELDS.PER_TRANSFERRED_ON_DEATH_UNDER_DEF_BENEFIT}`}
          variant={VARIANTS_TYPES.PERCENTAGE}
          disabled={isRetired}
        />

        <Field
          component={Fields.Text}
          title={FIELDS_QUESTIONS.REPAYMENT_LUMP_SUM_UNDER_DEFINED_BENEFIT}
          name={`${prefix}.${FIELDS.REPAYMENT_LUMP_SUM_UNDER_DEFINED_BENEFIT}`}
          variant={VARIANTS_TYPES.CURRENCY}
          disabled={isRetired}
        />
      </Columns>

      <Field
        component={Fields.Text}
        title={FIELDS_QUESTIONS.DEFINED_CONTRIBUTION_FUTURE}
        name={`${prefix}.${FIELDS.DEFINED_CONTRIBUTION}`}
        variant={VARIANTS_TYPES.CURRENCY}
        disabled={isRetired}
      />

      <Columns spacing={4}>
        <Field
          component={Fields.Text}
          title={FIELDS_QUESTIONS.ONGOING_CONTRIBUTIONS}
          name={`${prefix}.${FIELDS.ONGOING_CONTRIBUTIONS}`}
          variant={VARIANTS_TYPES.CURRENCY}
          disabled={isRetired}
        />
        <Field
          component={Fields.Text}
          title={FIELDS_QUESTIONS.PER_TRANSFERRED_ON_DEATH_UNDER_DEF_CONTRIBUTION}
          name={`${prefix}.${FIELDS.PER_TRANSFERRED_ON_DEATH_UNDER_DEF_CONTRIBUTION}`}
          variant={VARIANTS_TYPES.PERCENTAGE}
          disabled={isRetired}
        />
      </Columns>

      <Columns spacing={4}>
        <Field
          component={Fields.Text}
          title={FIELDS_QUESTIONS.LUMP_SUM_DRAWDOWN}
          name={`${prefix}.${FIELDS.LUMP_SUM_DRAWDOWN}`}
          variant={VARIANTS_TYPES.PERCENTAGE}
          disabled={isRetired}
        />
        <Field
          component={Fields.Text}
          title={FIELDS_QUESTIONS.REPAYMENT_LUMP_SUM_UNDER_DEFINED_CONTRIBUTION}
          name={`${prefix}.${FIELDS.REPAYMENT_LUMP_SUM_UNDER_DEFINED_CONTRIBUTION}`}
          variant={VARIANTS_TYPES.PERCENTAGE}
          disabled={isRetired}
        />
      </Columns>
      {getValue(FIELDS.DEFINED_CONTRIBUTION) > 0 && (
        <Field
          component={Fields.Select}
          title={FIELDS_QUESTIONS.USE_OF_FUNDS}
          name={`${prefix}.${FIELDS.USE_OF_FUNDS}`}
          options={useOfFunds}
          required
          disabled={isRetired}
        />
      )}
    </>
  );
};

export default FuturePension;
